import './App.css';
import {
    BrowserRouter as Router,
    Route,
    Routes,
} from "react-router-dom";
import {useState, useEffect} from "react";
import NavbarMenu from "./components/NavbarMenu";
import Footer from "./components/Footer";
import WelcomePage from "./components/WelcomePage";
import BlogPage from "./components/BlogPage";
import NotFoundPage from "./components/NotFoundPage";
// import LoginPage from "./components/LoginPage";
// import SignUpPage from "./components/SignUpPage";
import DashboardPage from "./components/DashboardPage";
import CreatePostPage from "./components/CreatePostPage";
import CreateCategoryPage from "./components/CreateCategoryPage";
import PostsListPage from "./components/PostsListPage";
import SinglePostShow from "./components/SinglePostShow";
import EditPostPage from "./components/EditPostPage";
// import ReserveVisit from "./components/ReserveVisit";
import ShowVisitTimes from "./components/ShowVisitTimes";
// import Agreements from "./components/Agreements";
import DownloadPage from "./components/DownloadPage";

function App() {
    const [mainLoggedUser, setMainLoggedUser] = useState({
        token: "",
        message: "",
        state: "",
        userNameFamily: "",
        userMode: ""
    });
    const [visitTime, setVisitTime] = useState([]);
    const [visitDate, setVisitDate] = useState("");

    useEffect(() => {
        const currentLoggedUser = JSON.parse(sessionStorage.getItem("user"));
        loggedUserControl(currentLoggedUser);
    }, []);


    // const [loggedUser, setLoggedUser] = useState({token: "", message: "", state: "", userNameFamily: "", userMode: ""});
    // const currentLoggedUser = JSON.parse(sessionStorage.getItem("user"));
    const loggedUserControl = (user) => {
        if (user != null && user.state === "success"
            && user.token !== mainLoggedUser.token) {
            setMainLoggedUser({
                state: user.state,
                token: user.token,
                message: user.message,
                userMode: user.user_mode,
                userNameFamily: user.user_name_family
            });
        } else {
            setMainLoggedUser({
                token: "",
                message: "",
                state: "",
                userNameFamily: "",
                userMode: ""
            })
        }
    }


    const [mainCatId, setMainCatId] = useState(0);
    const [subCatId, setSubCatId] = useState(0);
    const [postShow, setPostShow] = useState({});

    const categoryAndSubCategoryId = (ids) => {
        setMainCatId(ids[0]);
        setSubCatId(ids[1]);
        // console.log(ids)
    }
    const postShowSetter = (postItem) => {
        // setPostId(showId);
        setPostShow(postItem);
    }

    /*    const handleLoggedUser = (userModel) => {
            loggedUserControl(userModel);
        }*/

    const visitTimeAndDate = (times, date) => {
        setVisitDate(date);
        setVisitTime(times);
    }


    return (
        <Router>
            <NavbarMenu mainUser={mainLoggedUser} onUserLogged={loggedUserControl}/>
            <Routes>
                <Route path="/" element={<WelcomePage/>}/>
                <Route path="/download" element={<DownloadPage/>}/>
                <Route path="/blog" element={<BlogPage catIds={categoryAndSubCategoryId}/>}/>
                <Route path="/dashboard" element={<DashboardPage mainUser={mainLoggedUser}/>}/>
                {/*<Route path="/login" element={<LoginPage mainUser={mainLoggedUser} onUserLogged={loggedUserControl}/>}/>*/}
                {/*<Route path="/sign_up" element={<SignUpPage/>}/>*/}
                {/*<Route path="/reserve_visit" element={<ReserveVisit timeAndDate={visitTimeAndDate}/>}/>*/}
                {/*<Route path="/agreements" element={<Agreements/>}/>*/}

                {(mainLoggedUser.userMode === "admin") &&
                    <Route path="/create_post" element={<CreatePostPage mainUser={mainLoggedUser}
                                                                        categoryIdSetter={categoryAndSubCategoryId}/>}/>}
                {(mainLoggedUser.userMode === "admin") &&
                    <Route path="/edit_post" element={<EditPostPage mainUser={mainLoggedUser} postToEdit={postShow}
                                                                    categoryIdSetter={categoryAndSubCategoryId}/>}/>}
                {(mainLoggedUser.userMode === "admin") &&
                    <Route path="/create_category" element={<CreateCategoryPage mainUser={mainLoggedUser}/>}/>}
                <Route path="/posts_list"
                       element={<PostsListPage catIds={[mainCatId, subCatId]}
                                               postShowSet={postShowSetter}/>}/> {/*needs to be modified*/}
                <Route path="/read_single_post"
                       element={<SinglePostShow categoryIdSetter={categoryAndSubCategoryId} mainUser={mainLoggedUser}
                                                postShowSet={postShowSetter} postItemShow={postShow}/>}/>
                <Route path="*" element={<NotFoundPage/>}/>

                <Route path="/showVisitTimes" element={<ShowVisitTimes date={visitDate} times={visitTime}/>}/>

            </Routes>
            <Footer/>
        </Router>
    );
}

export default App;
